import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as debug from 'debug';
import { GoogleProvider } from '../../providers/google/google';

@Component({
  selector: 'reviews-for-place',
  templateUrl: 'reviews-for-place.html',
})
export class ReviewsForPlaceComponent {
  log = debug('app:ReviewsForPlaceComponent');

  @Input() reviews = [];
  @Input() place: any = {};
  @Output() openReviewsEvent = new EventEmitter<any>();

  constructor() {}
  openReviews() {
    this.openReviewsEvent.emit();
  }
}



// WEBPACK FOOTER //
// ./src/components/reviews-for-place/reviews-for-place.ts